import { render, staticRenderFns } from "./AddOtherIncomeForm.vue?vue&type=template&id=aa8b8bc2"
import script from "./AddOtherIncomeForm.vue?vue&type=script&lang=js"
export * from "./AddOtherIncomeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports